  <template >

 <div    >
     <template>
  <v-container class="grey lighten-5" v-role="'func'">
    <v-row no-gutters>
      <v-col >

      <div class="container">
    <line-chart
      v-if="loaded"
      :chartdata="chartdata"
      :options="options"/>
  </div>

      </v-col>

    </v-row>
  </v-container>
</template>

 </div>
</template>

<script>

import LineChart from '../../../components/Pie.vue'
export default {
  name: 'LineChartContainer',
  components: { LineChart },
  data: () => ({
    loaded: false,
    chartdata: {
      labels: ['January', 'February', 'Marco', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outbro', 'Novembro', 'Dezembro'],
      datasets: [
        {
          // label: ['red', 'blue' ],

          // Color: ['red', 'blue' ],
          borderColor: ['red', 'black', 'blue', 'yellow', 'REBECCAPURPLE', 'GOLD', 'Green', 'Purple', 'Orange', 'KHAKI', 'VIOLET', 'LIME'],

          backgroundColor: ['red', 'black', 'blue', 'yellow', 'REBECCAPURPLE', 'GOLD', 'Green', 'Purple', 'Orange', 'KHAKI', 'VIOLET', 'LIME'],
          data: [40, 20, 10, 2, 40, 20, 440, 20, 40, 230, 40, 420]
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false
    }
  }),
  async mounted () {
    this.loaded = false
    try {
    //  const { userlist } = await fetch('/api/userlist')
      // this.chartdata = ['January', 'February']
      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>
